import React, { useEffect, useState } from "react";
// Importing category images (assuming these are static assets)
import camera from "../../assets/AllCategories/CategoryImages/TopCategories/Consumer Electronics.png";
import home from "../../assets/AllCategories/CategoryImages/TopCategories/Home & Garden.png";
import beauty from "../../assets/AllCategories/CategoryImages/Baby care.png";
import fashion from "../../assets/AllCategories/CategoryImages/TopCategories/Fashion & Apparels.png";
import toys from "../../assets/AllCategories/CategoryImages/TopCategories/toys.png";
import sports from "../../assets/AllCategories/CategoryImages/TopCategories/Sports & Entertainment.png";
import industrialMachine from "../../assets/AllCategories/CategoryImages/industrial-machine.png"
import sustainableProduct from "../../assets/AllCategories/CategoryImages/sustainibility logo copy.png"
import PersonalCare from "../../assets/AllCategories/CategoryImages/TopCategories/Beauty.png"
import {
  allMainCategoryApi,
  getSubChildCategories,
} from "../../Apis/CategoryApi";
import { useNavigate } from "react-router-dom";
// import styles from './Categories.module.css'; // Import the CSS module

const Categories = () => {
  const [data, setData] = useState([]);
  const [subChildCategories, setSubChildCategories] = useState([]);
  const navigate = useNavigate(); // Add this line to use the useNavigate hook
  const [searchQuery, setSearchQuery] = useState("");
 const [filteredData, setFilteredData] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  // ... rest of your component code ...

  const handleViewAllProducts = () => {
    navigate("/AllProductsPage"); // Redirect to inquiries page
  };

  useEffect(() => {
    async function fetchData() {
      const response = await allMainCategoryApi();
      setData(response?.category);

      const subCategoryList = [];
      for (let i = 0; i < response?.category?.length; i++) {
        const subCategoryResponse = await getSubChildCategories(
          response?.category[i]
        );

        const mainCategory = response?.category[i];
        subCategoryList.push({
          mainCategory,
          subCategory: subCategoryResponse?.category?.slice(0, 3)?.map((element) => element?.subCategory),
        });
      }
      setSubChildCategories(subCategoryList);
      setFilteredData(response?.category);
      setFilteredSubCategories(subCategoryList);
    }
    fetchData();
  }, []);

  useEffect(() => {
    const trimmedSearchQuery = searchQuery.trim().toLowerCase();

    const filteredData = data.filter((category) =>
      category.toLowerCase().includes(trimmedSearchQuery)
    );

    const filteredSubCategories = subChildCategories.filter((item) => {
      const mainCategoryMatches = item.mainCategory
        .toLowerCase()
        .includes(trimmedSearchQuery);

      const subCategoryMatches = item.subCategory?.some((sub) =>
        sub?.toLowerCase().includes(trimmedSearchQuery)
      );

      return mainCategoryMatches || subCategoryMatches;
    });

    setFilteredData(filteredData);
    setFilteredSubCategories(filteredSubCategories);
  }, [searchQuery, data, subChildCategories]);

 
  
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  }

  // Object mapping for category images (assuming these are static)
  const categoryImages = {
    "Consumer Electronics": camera,
    "Fashion & Apparel": fashion,
    Toys: toys,
    "Sports & Entertainment": sports,
    "Home and Decor": home,
    "Baby care": beauty,
    "Industrial Machines": industrialMachine,
    "Sustainable Products": sustainableProduct,
    "Beauty & Personal Care": PersonalCare,
    
  };

  return (
    <>
      <div className="w-full h-[1500px]">
        <div className="max-w-[1240px] m-auto h-[1500px] mt-[50px] flex flex-col">
          <h2 className="text-[18px] font-semibold w-[150px] h-[30px] text-black">
            All Categories
          </h2>

          <hr className="bg-[#FF8100] w-[192px] h-[3px] rounded-full mt-[5px]" />

          <div className="w-[1240px] h-[50px] bg-white rounded-[10px] p-[8px] mt-[27px] drop-shadow-[0_0px_1px_rgba(0,0,0,0.20)] flex items-center justify-between">
            <div className="flex flex-row h-[34px] items-center justify-start gap-x-[6px]">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                className="text-[#C8C8C8]"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.7208 11.2498C3.75935 12.2898 5.14237 12.9142 6.60932 13.0052C8.07627 13.0963 9.52587 12.6477 10.685 11.7441L14.6735 15.7326C14.815 15.8692 15.0044 15.9448 15.2011 15.9431C15.3977 15.9414 15.5859 15.8625 15.7249 15.7234C15.864 15.5844 15.9428 15.3963 15.9446 15.1996C15.9463 15.003 15.8707 14.8135 15.734 14.6721L11.7455 10.6836C12.6893 9.47245 13.1354 7.94694 12.9931 6.41816C12.8507 4.88937 12.1305 3.47247 10.9794 2.45643C9.82828 1.44038 8.33292 0.901713 6.79829 0.950287C5.26366 0.998861 3.80536 1.63102 2.7208 2.71783C2.16039 3.27795 1.71584 3.94299 1.41254 4.67496C1.10924 5.40694 0.953125 6.1915 0.953125 6.98383C0.953125 7.77615 1.10924 8.56072 1.41254 9.29269C1.71584 10.0247 2.16039 10.6897 2.7208 11.2498ZM3.7813 3.77983C4.52273 3.03841 5.49829 2.57701 6.54177 2.47423C7.58525 2.37144 8.63208 2.63364 9.50392 3.21615C10.3758 3.79865 11.0187 4.66543 11.3231 5.66879C11.6275 6.67215 11.5746 7.75003 11.1734 8.71877C10.7722 9.68752 10.0476 10.4872 9.12289 10.9815C8.19822 11.4759 7.13074 11.6344 6.10234 11.4299C5.07393 11.2255 4.14823 10.6708 3.48294 9.86033C2.81766 9.0499 2.45395 8.03386 2.4538 6.98533C2.45174 6.38951 2.56802 5.79921 2.79591 5.24869C3.02379 4.69817 3.35873 4.19838 3.7813 3.77833V3.77983Z"
                  fill="#C8C8C8"
                />
              </svg>

              <input
                type="text"
                className="placeholder:w-[900px] placeholder:h-[20px] placeholder:text-[#C8C8C8] placeholder:font-medium placeholder:text-[14px] w-[900px] text-[14px] text-black font-medium"
                placeholder="Search categories, sub-categories"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>

            <button className="w-[115px] h-[33px] bg-[#FF6300] rounded-[5px] gap-x-[8px] flex flex-row font-semibold items-center justify-center">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.61314 9.24943C3.4209 10.0583 4.49658 10.5439 5.63754 10.6147C6.7785 10.6855 7.90597 10.3367 8.80755 9.63385L11.9097 12.736C12.0197 12.8423 12.1671 12.9011 12.32 12.8997C12.473 12.8984 12.6193 12.8371 12.7274 12.7289C12.8356 12.6208 12.897 12.4744 12.8983 12.3215C12.8996 12.1686 12.8408 12.0212 12.7346 11.9112L9.63239 8.80902C10.3664 7.86703 10.7134 6.68052 10.6027 5.49146C10.492 4.30241 9.93182 3.20038 9.0365 2.41012C8.14118 1.61986 6.97812 1.2009 5.78452 1.23868C4.59092 1.27646 3.45669 1.76813 2.61314 2.61343C2.17727 3.04908 1.83151 3.56634 1.5956 4.13565C1.3597 4.70496 1.23828 5.31518 1.23828 5.93143C1.23828 6.54769 1.3597 7.1579 1.5956 7.72722C1.83151 8.29653 2.17727 8.81379 2.61314 9.24943ZM3.43797 3.43943C4.01464 2.86278 4.77341 2.50391 5.585 2.42396C6.3966 2.34402 7.2108 2.54795 7.8889 3.00101C8.56699 3.45407 9.06702 4.12823 9.3038 4.90863C9.54057 5.68902 9.49943 6.52737 9.1874 7.28083C8.87536 8.0343 8.31174 8.65627 7.59254 9.04077C6.87335 9.42527 6.04309 9.54851 5.24322 9.3895C4.44335 9.23048 3.72336 8.79905 3.20592 8.16871C2.68847 7.53837 2.40559 6.74812 2.40547 5.9326C2.40387 5.46918 2.49431 5.01006 2.67156 4.58188C2.8488 4.1537 3.10931 3.76497 3.43797 3.43827V3.43943Z"
                  fill="white"
                />
              </svg>

              <p className="w-[50px] h-[21px] font-medium text-[14px] text-white">
                Search
              </p>
            </button>
          </div>

          <div className="flex flex-wrap gap-x-[22px] gap-y-[24px] mt-[27px]">
            {filteredData?.map((item, index) => (
              <div
                key={item}
                className="w-[293px] h-[430px] bg-white flex flex-col rounded-[10px] p-[16px] drop-shadow-[0_0px_1.5px_rgba(0,0,0,0.20)]"
              >
                <div className="w-full h-[36px] flex items-center justify-between">
                  <p className="h-[24px] text-black font-semibold text-[16px]">
                    {item}
                  </p>
                  <button
                    className="w-[36px] h-[36px] bg-white flex items-center justify-center rounded-full drop-shadow-[0_0px_2px_rgba(0,0,0,0.20)]"
                    onClick={handleViewAllProducts}
                  >
               
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"                                                                  
                    > 
                      <path
                        d="M8.66797 5L14.5013 10.8333L8.66797 16.6667"
                        stroke="#FF6300"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <div className="w-[261px] h-[261px] bg-[#F2F2F2] rounded-[15px] flex items-center justify-center mt-[8px]">
                  <img
                    // className={styles.customImageSize} // Using the custom class
                    className="w-[170px] h-[170px]"
                    src={categoryImages[item]}
                    alt="img1"
                  />
                </div>
                <div className="w-[261px] h-[85px] mt-[10px] text-[#919191] font-medium text-[16px]">
                  {filteredSubCategories[index]?.subCategory?.map((data) => (
                    <div key={data}>{data}</div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Categories;



 